import { render } from "./FormsSurvey.vue?vue&type=template&id=31e24416"
import script from "./FormsSurvey.vue?vue&type=script&lang=js"
export * from "./FormsSurvey.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-nps\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__